import axios from 'axios';
import { CONFIG } from 'variables/config';

// The account API key is never kept client-side (no localStorage): it's fetched from the backend
// only when the user explicitly clicks to show/use it (POST /account/api-key/reveal, JWT-only),
// and held in component state for as long as the page stays open.
export async function revealApiKey(): Promise<string> {
    const res = await axios.post(
        `${CONFIG.apiUrl}/account/api-key/reveal`,
        {},
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } }
    );
    return res.data.apiKey;
}

export const maskApiKey = (key: string) => `${key.slice(0, 11)}${'•'.repeat(20)}`;
